import { ReactComponent as Icon1 } from "@/assets/icons/usp/fda-registered-icon.svg";
import { ReactComponent as Icon2 } from "@/assets/icons/usp/board-certified-icon.svg";
import { ReactComponent as Icon3 } from "@/assets/icons/usp/pharmacopeia-icon.svg";

export const USP_LIST = [
  {
    title: "State-licensed 503A\nCompounding Pharmacy",
    icon: <Icon1 />,
  },
  {
    title: "Reviewed by Board-Certified\nMedical Professionals",
    icon: <Icon2 />,
  },
  {
    title: "United States Pharmacopeia\n(USP) Compliance Guaranteed",
    icon: <Icon3 />,
  },
];
